import commonApi from './CommonApi.js';

export default {
    browse: async (parameters) => {
        return await commonApi().get('/notification-types/browse', { params: parameters, paramsSerializer: params => { return qs.stringify(params) } })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                console.log(error.response);
            });
    },
    getDropdownItems: async (parameters) => {
        return await commonApi().get('/notification-types/get-dropdown-items', { params: parameters })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                console.log(error.response);
            });
    },
}